import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { intlMessageShape } from '@jutro/prop-types';
import { InlineNotification } from '@jutro/components';

const inlineTypes = {
    WARNING: 'warning',
    ERROR: 'error',
    INFO: 'info',
    SUCCESS: 'success',
};

const MLInlineNotificationClasses = {
    warning: 'ml-alert ml-alert-warning',
    info: '', // use default as ML does not have specific info styling
    success: 'ml-alert ml-alert-success',
    error: 'ml-alert ml-alert-error'

}

function MLInlineNotification(props) {
    const { type, className, ...rest } = props

    const classes = cx(
        MLInlineNotificationClasses[type],
        className
    );

    return <InlineNotification {...rest} type={type} className={classes} />
}

MLInlineNotification.propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    message: intlMessageShape,
    type: PropTypes.oneOf([
        inlineTypes.SUCCESS,
        inlineTypes.INFO,
        inlineTypes.WARNING,
        inlineTypes.ERROR,
    ]),
    onClosed: PropTypes.func,
    isDismissable: PropTypes.bool,
    isEmbeddedNotification: PropTypes.bool,
    messageProps: PropTypes.shape({
        success: intlMessageShape,
        warning: intlMessageShape,
        info: intlMessageShape,
        error: intlMessageShape,
        dismissLabel: intlMessageShape,
    })
}

MLInlineNotification.defaultProps = {
    type: inlineTypes.INFO,
}

export default MLInlineNotification